import {
  GuestJourneyOffer,
  GuestJourneyOfferImpactCards,
  GuestJourneySankeyResponse,
} from '../guest-journey-reports.types';

/** GJ-scoped offer list backing the Offer Impact filter dropdown. */
export const guestJourneyOffersFixture: GuestJourneyOffer[] = [
  {
    offerId: 'offer-1',
    offerName: 'Summer BOGO Entrées',
    offerDate: '2026-05-01',
  },
  { offerId: 'offer-2', offerName: '$5 Off $25', offerDate: '2026-04-15' },
  {
    offerId: 'offer-3',
    offerName: 'Free Delivery Weekend',
    offerDate: '2026-03-20',
  },
];

// Values arrive pre-formatted from the BE. The four "after redemption" cards
// carry a `trend` — the "vs previous period" delta, expressed as a
// PulseMovementIndicator (replacing the old `comparisonNumber` mechanism).
export const offerImpactCardsFixture: GuestJourneyOfferImpactCards = {
  avgCheck30d: {
    title: 'Avg Check (30d)',
    value: '$36.50',
    trend: { text: '+7% vs prev', direction: 'UP' },
  },
  avgVisits30d: {
    title: 'Avg Visits (30d)',
    value: '1.8',
    trend: { text: '+12.5% vs prev', direction: 'UP' },
  },
  avgCheck90d: {
    title: 'Avg Check (90d)',
    value: '$38.20',
    trend: { text: '+2.1% vs prev', direction: 'UP' },
  },
  avgVisits90d: {
    title: 'Avg Visits (90d)',
    value: '4.2',
    trend: { text: '-6.7% vs prev', direction: 'DOWN' },
  },
  membersChangedStage: { title: 'Members Changed Stage', value: '6.6' },
  avgCheckOnRedemption: { title: 'Avg Check on Redemption', value: '$38.65' },
  totalDistributions: { title: 'Total Distributions', value: '7,462' },
  totalRedemptions: { title: 'Total Redemptions', value: '1,020' },
  redemptionRate: { title: 'Redemption Rate', value: '13.7%' },
  totalDiscount: { title: 'Total Discount', value: '$6,072.30' },
  totalSpendNetSales: { title: 'Total Spend (Net Sales)', value: '$39,430.50' },
  discountRatio: { title: 'Discount Ratio', value: '13.3%' },
};

/**
 * Single movement payload (BE `PulseSankeyDTO`). Incoming flows are the source
 * segments that redeemed — STABLE movement so the inbound bands render
 * neutral grey (no directional coloring; the Incoming table hides the
 * Movement column). Outgoing flows stay per destination stage with the
 * BE-sent directional bucket text in `movement`; the sankey aggregates them
 * into buckets via `buildMovementSankey({ aggregateOutgoingByMovement })`
 * while the Outgoing table renders the per-stage rows (story 357748).
 */
export const offerImpactSankeyFixture: GuestJourneySankeyResponse = {
  stayedCount: 0,
  incoming: [
    {
      stage: 'Value Explorer',
      count: 410,
      totalVisits: 19,
      totalSpendPerCustomer: 75.3,
      movement: { text: 'Redeemed', direction: 'STABLE' },
    },
    {
      stage: 'Value Regular',
      count: 230,
      totalVisits: 17,
      totalSpendPerCustomer: 68.9,
      movement: { text: 'Redeemed', direction: 'STABLE' },
    },
    {
      stage: 'Core Explorer',
      count: 160,
      totalVisits: 12,
      totalSpendPerCustomer: 46.4,
      movement: { text: 'Redeemed', direction: 'STABLE' },
    },
    {
      stage: 'Slider',
      count: 120,
      totalVisits: 8,
      totalSpendPerCustomer: 32.1,
      movement: { text: 'Redeemed', direction: 'STABLE' },
    },
    {
      stage: 'Indulgent Regular',
      count: 80,
      totalVisits: 22,
      totalSpendPerCustomer: 92.4,
      movement: { text: 'Redeemed', direction: 'STABLE' },
    },
  ],
  outgoing: [
    {
      stage: 'Core Superfan',
      count: 140,
      totalVisits: 18,
      totalSpendPerCustomer: 72.1,
      movement: { text: 'Moved Up', direction: 'UP_RIGHT' },
    },
    {
      stage: 'Indulgent Regular',
      count: 90,
      totalVisits: 21,
      totalSpendPerCustomer: 84.7,
      movement: { text: 'Moved Up', direction: 'UP_RIGHT' },
    },
    {
      stage: 'Value Regular',
      count: 160,
      totalVisits: 15,
      totalSpendPerCustomer: 36.8,
      movement: { text: 'Moved out of At Risk', direction: 'UP_RIGHT' },
    },
    {
      stage: 'Value Superfan',
      count: 90,
      totalVisits: 19,
      totalSpendPerCustomer: 78.4,
      movement: { text: 'Moved into a Neutral Stage', direction: 'STABLE' },
    },
    // Two destinations sharing one bucket — the sankey sums them into a
    // single "At Risk (Slider + Churned)" band; the table keeps both rows.
    {
      stage: 'Slider',
      count: 70,
      totalVisits: 4,
      totalSpendPerCustomer: 22.5,
      movement: { text: 'At Risk (Slider + Churned)', direction: 'DOWN_LEFT' },
    },
    {
      stage: 'Churned',
      count: 80,
      totalVisits: 0,
      totalSpendPerCustomer: 0,
      movement: { text: 'At Risk (Slider + Churned)', direction: 'DOWN_LEFT' },
    },
    {
      stage: 'Core Regular',
      count: 620,
      totalVisits: 9,
      totalSpendPerCustomer: 41.2,
      movement: { text: "Didn't Move Stage", direction: 'STABLE' },
    },
  ],
};
